module.exports = fox._r("images/press/press-blog-post.jpg", __webpack_public_path__ + "_/common/images/press/press-blog-post.jpg");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/press-blog-post.jpg
// module id = 378
// module chunks = 2